import {
  //
  GET_PREVIEW,
  GET_PREVIEW_SUCCESS,
  GET_PREVIEW_FAILURE,
  //
  GET_TEMPLATE_DATA,
  GET_TEMPLATE_DATA_SUCCESS,
  GET_TEMPLATE_DATA_FAILURE,
  //
  SAVE_TEMPLATE_DATA,
  SAVE_TEMPLATE_DATA_SUCCESS,
  SAVE_TEMPLATE_DATA_FAILURE,
  //
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  //
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  //
  SEARCH_TEMPLATES,
  SEARCH_TEMPLATES_SUCCESS,
  SEARCH_TEMPLATES_FAILURE,
  //
  GET_CARE_SUMMARY,
  GET_CARE_SUMMARY_SUCCESS,
  GET_CARE_SUMMARY_FAILURE,
  //
  GET_VERSION_DATA,
  GET_VERSION_DATA_SUCCESS,
  GET_VERSION_DATA_FAILURE,
  //
  UPDATE_TEMPLATE_DATA,
  UPDATE_TEMPLATE_DATA_SUCCESS,
  UPDATE_TEMPLATE_DATA_FAILURE,
  //
  SAVE_SNAPSHOT,
  SAVE_SNAPSHOT_SUCCESS,
  SAVE_SNAPSHOT_FAILURE,
  //
  DELETE_VERSION,
  DELETE_VERSION_SUCCESS,
  DELETE_VERSION_FAILURE,
  //
  GET_CURRENT_TEMPLATE,
  GET_CURRENT_TEMPLATE_SUCCESS,
  GET_CURRENT_TEMPLATE_FAILURE,
  //
  RECORD_OBSERVATION,
  //
  ADD_TEMPLATE_DATA,
  ADD_TEMPLATE_DATA_SUCCESS,
  ADD_TEMPLATE_DATA_FAILURE,
  //
  GET_REVISION,
  GET_REVISION_SUCCESS,
  GET_REVISION_FAILURE,
  //
  VIEW_REVISION,
  VIEW_REVISION_SUCCESS,
  VIEW_REVISION_FAILURE,
  //
  GET_GOVERNANCE_STATS,
  GET_GOVERNANCE_STATS_SUCCESS,
  GET_GOVERNANCE_STATS_FAILURE,
  //
  UPDATE_PLAN_STATUS,
  UPDATE_PLAN_STATUS_SUCCESS,
  UPDATE_PLAN_STATUS_FAILURE,
} from "./constants";

// List
export const getPreview = (payload, onSuccess) => ({
  type: GET_PREVIEW,
  payload,
  onSuccess,
});
export const getPreviewSuccess = (payload) => ({
  type: GET_PREVIEW_SUCCESS,
  payload,
});
export const getPreviewFailure = (payload) => ({
  type: GET_PREVIEW_FAILURE,
  payload,
});

// Template Data
export const getTemplateData = (payload, onSuccess) => ({
  type: GET_TEMPLATE_DATA,
  payload,
  onSuccess,
});
export const getTemplateDataSuccess = (payload) => ({
  type: GET_TEMPLATE_DATA_SUCCESS,
  payload,
});

export const getTemplateDataFailure = (payload) => ({
  type: GET_TEMPLATE_DATA_FAILURE,
  payload,
});

// Save Template Data
// The optional third arg `onReviewRequired` is the AI human-review gate's
// recovery hook: the saga calls it INSTEAD of raising the generic error alert
// when the API refuses this save with 422 { reason: 'ai_review_required' }, so
// the caller can confirm and re-send with `ai_authoring.reviewed_ack`. Omit it
// and the failure path is exactly as before.
export const saveTemplateData = (
  payload,
  onSuccess,
  onReviewRequired,
  onWoundConflict,
) => ({
  type: SAVE_TEMPLATE_DATA,
  payload,
  onSuccess,
  onReviewRequired,
  onWoundConflict,
});
export const saveTemplateDataSuccess = (payload) => ({
  type: SAVE_TEMPLATE_DATA_SUCCESS,
  payload,
});
export const saveTemplateDataFailure = (payload) => ({
  type: SAVE_TEMPLATE_DATA_FAILURE,
  payload,
});

// Upload File
export const uploadFile = (payload, onSuccess) => ({
  type: UPLOAD_FILE,
  payload,
  onSuccess,
});
export const uploadFileSuccess = (payload) => ({
  type: UPLOAD_FILE_SUCCESS,
  payload,
});
export const uploadFileFailure = (payload) => ({
  type: UPLOAD_FILE_FAILURE,
  payload,
});

// Delete File
export const deleteFile = (payload, onSuccess) => ({
  type: DELETE_FILE,
  payload,
  onSuccess,
});
export const deleteFileSuccess = (payload) => ({
  type: DELETE_FILE_SUCCESS,
  payload,
});
export const deleteFileFailure = (payload) => ({
  type: DELETE_FILE_FAILURE,
  payload,
});

// Search Templates
export const searchTemplates = (payload, onSuccess, onError) => ({
  type: SEARCH_TEMPLATES,
  payload,
  onSuccess,
  onError,
});
export const searchTemplatesSuccess = (payload) => ({
  type: SEARCH_TEMPLATES_SUCCESS,
  payload,
});
export const searchTemplatesFailure = (payload) => ({
  type: SEARCH_TEMPLATES_FAILURE,
  payload,
});

// Get Care Summary
export const getCareSummary = (payload, onSuccess) => ({
  type: GET_CARE_SUMMARY,
  payload,
  onSuccess,
});
export const getCareSummarySuccess = (payload) => ({
  type: GET_CARE_SUMMARY_SUCCESS,
  payload,
});
export const getCareSummaryFailure = (payload) => ({
  type: GET_CARE_SUMMARY_FAILURE,
  payload,
});

// Get Version Data
export const getVersionData = (payload, onSuccess) => ({
  type: GET_VERSION_DATA,
  payload,
  onSuccess,
});
export const getVersionDataSuccess = (payload) => ({
  type: GET_VERSION_DATA_SUCCESS,
  payload,
});
export const getVersionDataFailure = (payload) => ({
  type: GET_VERSION_DATA_FAILURE,
  payload,
});

// Update Template Data
// The optional third arg `onReviewRequired` is the AI human-review gate's
// recovery hook: the saga calls it INSTEAD of raising the generic error alert
// when the API refuses this save with 422 { reason: 'ai_review_required' }, so
// the caller can confirm and re-send with `ai_authoring.reviewed_ack`. Omit it
// and the failure path is exactly as before.
export const updateTemplateData = (payload, onSuccess, onReviewRequired) => ({
  type: UPDATE_TEMPLATE_DATA,
  payload,
  onSuccess,
  onReviewRequired,
});
export const updateTemplateDataSuccess = (payload) => ({
  type: UPDATE_TEMPLATE_DATA_SUCCESS,
  payload,
});
export const updateTemplateDataFailure = (payload) => ({
  type: UPDATE_TEMPLATE_DATA_FAILURE,
  payload,
});

// Save Snapshot
export const saveSnapshot = (payload, onSuccess) => ({
  type: SAVE_SNAPSHOT,
  payload,
  onSuccess,
});
export const saveSnapshotSuccess = (payload) => ({
  type: SAVE_SNAPSHOT_SUCCESS,
  payload,
});
export const saveSnapshotFailure = (payload) => ({
  type: SAVE_SNAPSHOT_FAILURE,
  payload,
});

// Delete Version
export const deleteVersion = (payload, onSuccess) => ({
  type: DELETE_VERSION,
  payload,
  onSuccess,
});
export const deleteVersionSuccess = (payload) => ({
  type: DELETE_VERSION_SUCCESS,
  payload,
});
export const deleteVersionFailure = (payload) => ({
  type: DELETE_VERSION_FAILURE,
  payload,
});

// Get Assessment Data
export const getCurrentTemplate = (payload, onSuccess) => ({
  type: GET_CURRENT_TEMPLATE,
  payload,
  onSuccess,
});
export const getCurrentTemplateSuccess = (payload) => ({
  type: GET_CURRENT_TEMPLATE_SUCCESS,
  payload,
});
export const getCurrentTemplateFailure = (payload) => ({
  type: GET_CURRENT_TEMPLATE_FAILURE,
  payload,
});

// v2 catalog-driven recording → POST /api/observations (single store + dual-write)
export const recordObservation = (payload, onSuccess, onError) => ({
  type: RECORD_OBSERVATION,
  payload,
  onSuccess,
  onError,
});

// Add Template Data
// The optional third arg `onReviewRequired` is the AI human-review gate's
// recovery hook: the saga calls it INSTEAD of raising the generic error alert
// when the API refuses this save with 422 { reason: 'ai_review_required' }, so
// the caller can confirm and re-send with `ai_authoring.reviewed_ack`. Omit it
// and the failure path is exactly as before.
// `onWoundConflict` is the wound↔plan binding's refusal hook: the API answers a
// create that names a wound already bound to another plan with
// 409 { data: { reason: 'wound_already_planned', existing_care_plan_id } }.
// Recoverable but NEVER retryable — the caller offers the existing plan instead.
export const addTemplateData = (
  payload,
  onSuccess,
  onReviewRequired,
  onWoundConflict,
) => ({
  type: ADD_TEMPLATE_DATA,
  payload,
  onSuccess,
  onReviewRequired,
  onWoundConflict,
});
export const addTemplateDataSuccess = (payload) => ({
  type: ADD_TEMPLATE_DATA_SUCCESS,
  payload,
});
export const addTemplateDataFailure = (payload) => ({
  type: ADD_TEMPLATE_DATA_FAILURE,
  payload,
});

// Get Revision
export const getRevision = (payload, onSuccess) => ({
  type: GET_REVISION,
  payload,
  onSuccess,
});
export const getRevisionSuccess = (payload) => ({
  type: GET_REVISION_SUCCESS,
  payload,
});
export const getRevisionFailure = (payload) => ({
  type: GET_REVISION_FAILURE,
  payload,
});

// View Revision
export const viewRevision = (payload, onSuccess) => ({
  type: VIEW_REVISION,
  payload,
  onSuccess,
});
export const viewRevisionSuccess = (payload) => ({
  type: VIEW_REVISION_SUCCESS,
  payload,
});
export const viewRevisionFailure = (payload) => ({
  type: VIEW_REVISION_FAILURE,
  payload,
});

// Get Governance Stats
export const getGovernanceStats = (payload, onSuccess) => ({
  type: GET_GOVERNANCE_STATS,
  payload,
  onSuccess,
});
export const getGovernanceStatsSuccess = (payload) => ({
  type: GET_GOVERNANCE_STATS_SUCCESS,
  payload,
});
export const getGovernanceStatsFailure = (payload) => ({
  type: GET_GOVERNANCE_STATS_FAILURE,
  payload,
});

// Update Plan Status
export const updatePlanStatus = (payload, onSuccess) => ({
  type: UPDATE_PLAN_STATUS,
  payload,
  onSuccess,
});
export const updatePlanStatusSuccess = (payload) => ({
  type: UPDATE_PLAN_STATUS_SUCCESS,
  payload,
});
export const updatePlanStatusFailure = (payload) => ({
  type: UPDATE_PLAN_STATUS_FAILURE,
  payload,
});
